import { TRESPONSE_TNA_BOARD_LISTING, TMaterialInHouseByOtlResponse } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableRowNode, TCellMarker } from '../../table.type';
import { getStripColorPatternMap } from 'libs/ui/src/lib/timeline/model/timeline.utils';
import { DateUtils } from '@monorepo/utils';

export const TNA_BOARD_STRIP_TABLE_MODEL = {
  createModel: (
    items: TRESPONSE_TNA_BOARD_LISTING['tnaBoardStripList'][number]['stepInfoList'],
    stipMetadata: TRESPONSE_TNA_BOARD_LISTING['stripStatusMetadataMap'],
    materialInHouseData?: TMaterialInHouseByOtlResponse,
  ) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        padding: 8,
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'STEPS',
          },
          {
            type: 'TEXT_CELL',
            text: 'STAGE',
          },
          {
            type: 'TEXT_CELL',
            text: 'Material In-house Progress',
            widthInPx: 160,
          },
          {
            type: 'TEXT_CELL',
            text: 'RESPONSIBLE PEOPLE',
          },
          {
            type: 'TEXT_CELL',
            text: 'TARGET DATE',
          },
          {
            type: 'TEXT_CELL',
            text: 'EXPECTED DATE',
          },
          {
            type: 'TEXT_CELL',
            text: 'DATE FROM PLAN',
          },
          {
            type: 'TEXT_CELL',
            text: 'COMPLETED AT DATE',
          },
          {
            type: 'TEXT_CELL',
            text: 'DELAY BY',
          },
          {
            type: 'TEXT_CELL',
            text: 'DELAY REASON',
          },
          {
            type: 'TEXT_CELL',
            text: 'PROGRESS',
          },
          {
            type: 'TEXT_CELL',
            text: 'ADDITIONAL DETAILS',
          },
          {
            type: 'TEXT_CELL',
            text: 'Material In-house',
            widthInPx: 100,
            stickyType: 'RIGHT',
          },
        ],
      },
      (item): TTableRowNode<TRESPONSE_TNA_BOARD_LISTING['tnaBoardStripList'][number]['stepInfoList'][number]> => {
        const materialProgress = materialInHouseData?.stepWiseMaterialDetails.find(
          (detail) => detail.tnaStepMaterialType === item.step,
        )?.cumulativeProgress;

        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            {
              type: 'TEXT_CELL',
              text: item.step,
              marker: {
                color: getStripColorPatternMap(stipMetadata[item.tnaBoardStepStatus].stripColor).color,
                iconId: getStripColorPatternMap(stipMetadata[item.tnaBoardStepStatus].stripColor)
                  .iconId as TCellMarker['iconId'],
              },
            },
            {
              type: 'TEXT_CELL',
              text: item.stage,
            },
            materialProgress !== null && materialProgress !== undefined
              ? {
                  type: 'PROGRESS_BAR_CELL',
                  color: 'primary',
                  value: (materialProgress ?? 0) / 100,
                }
              : {
                  type: 'TEXT_CELL',
                  text: '- -',
                },
            {
              type: 'TEXT_LIST_CELL',
              text: item.employees.length
                ? item.employees.map((employee) => `${employee.employeeName} (${employee.employeeId})`)
                : ['--'],
            },
            {
              type: 'TEXT_CELL',
              text: DateUtils.getDisplayDateStringFromDate(item.targetDate),
            },
            {
              type: 'TEXT_CELL',
              text: item.expectedDate ? DateUtils.getDisplayDateStringFromDate(item.expectedDate) : '--',
            },
            {
              type: 'TEXT_CELL',
              text: item.dateFromPlan ? DateUtils.getDisplayDateStringFromDate(item.dateFromPlan) : '--',
            },
            {
              type: 'TEXT_CELL',
              text: item.completedDate ? DateUtils.getDisplayDateStringFromDate(item.completedDate) : '--',
            },
            {
              type: 'TEXT_CELL',
              text: item.delayInDays || '--',
            },
            {
              type: 'TEXT_CELL',
              text: item.delayReason || '--',
            },
            {
              type: 'TEXT_CELL',
              text: item.isInProgress ? 'Yes' : '- -',
            },
            {
              type: 'TEXT_CELL',
              text: item.additionalDetails || '--',
            },
            materialProgress !== null && materialProgress !== undefined
              ? {
                  type: 'TEXT_CELL',
                  text: 'View Progress',
                  hrefActionCB: 'VIEW_MATERIAL_IN_HOUSE_PROGRESS',
                }
              : {
                  type: 'TEXT_CELL',
                  text: 'Not Applicable',
                },
          ],
        };
      },
    );
  },

  createIdentityModel: (items: TRESPONSE_TNA_BOARD_LISTING['tnaBoardStripList'][number]['stepInfoList']) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        padding: 8,
        headerConfig: [],
      },
      (item): TTableRowNode<TRESPONSE_TNA_BOARD_LISTING['tnaBoardStripList'][number]['stepInfoList'][number]> => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [],
        };
      },
    );
  },
};
